import { useEffect, useRef } from 'react'
import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { Box } from '@mui/material'
import theme from './theme'
import { application } from './data/info'
import ResponsiveAppBar from './components/layout/AppBar'
import Home from './components/sections/Home'
import About from './components/sections/About'
import Apply from './components/sections/Apply'
import Topics from './components/sections/Topics'
import Apps from './components/sections/Apps'
import StudentApps from './components/sections/StudentApps'
import Mentors from './components/sections/Mentors'
import Numbers from './components/sections/Numbers'
import Contact from './components/sections/Contact'
import scrollToElement from './util/scrollToElement'
import popupImage from './resources/popup.png'

function App() {
    const modalRef = useRef(null)

  // Scroll to hash section on page load (fixes mobile and Safari)
  useEffect(() => {
    // Prevent browser from restoring previous scroll position on reload,
    // which causes compounding scroll on mobile
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }

    const hash = window.location.hash.replace('#', '')
    if (hash) {
      // Reset to top first so the position calculation is clean
      window.scrollTo(0, 0)

      // requestAnimationFrame ensures Safari has painted before we scroll,
      // then the timeout waits for React sections to fully render
      requestAnimationFrame(() => {
        setTimeout(() => {
          scrollToElement(hash)
        }, 150)
      })
    }
  }, [])

  useEffect(() => {
    if (application.applicationsOpen) {
      modalRef.current?.showModal()
    }
  }, [])

  const closeModal = () => {
    modalRef.current?.close()
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box>
          <ResponsiveAppBar />
          <section id="Home">
            <Home />
          </section>
          <section id="Sobre">
            <About />
          </section>
          <section id="Processo">
            <Apply />
            <Topics />
          </section>
          <section id="Apps">
            <StudentApps />
            <Apps />
          </section>
          <section id="Mentoria">
            <Mentors />
          </section>
          <Numbers />
          <section id="Contato">
            <Contact />
          </section>
        </Box>
      </ThemeProvider>
      <dialog
        ref={modalRef}
        id="show_modal"
        className="modal !bg-transparent !border-0 !p-0 !shadow-none"
      >
        <div className="modal-box !bg-transparent !shadow-none !p-0 !m-0 !overflow-visible w-auto max-w-[90vw]">
          <a
            href="./processo"
            className="block outline-none"
            onClick={closeModal}
          >
            <img
              src={popupImage}
              className="block max-h-[85vh] max-w-[90vw] w-auto h-auto"
              alt="Inscreva-se no processo seletivo"
            />
          </a>
        </div>

        <form method="dialog" className="modal-backdrop">
          <button>close</button>
        </form>
      </dialog>
    </>
  )
}

export default App
